/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/


export default {
  /*SET_TODO_SEARCH_QUERY (state, query) {
    state.todoSearchQuery = query
  },
  UPDATE_TODO_FILTER (state, filter) {
    state.todoFilter = filter
  },

  // API
  SET_TASKS (state, tasks) {
    state.tasks = tasks
  },
  SET_TAGS (state, tags) {
    state.taskTags = tags
  },
  ADD_TASK (state, task) {
    state.tasks.unshift(task)
  },
  UPDATE_TASK (state, task) {
    const taskIndex = state.tasks.findIndex((t) => t.id === task.id)
    Object.assign(state.tasks[taskIndex], task)
  },*/
  ADD_SELECTED_CHARACTERISTIC (state, characteristic) {
    state.characteristic = characteristic
  },
  ADD_SKILL_STEP (state, step){
    state.addSkillStep = step
  },
  REMOVE_SELECTED_CHARACTERISTIC (state, characteristic) {
    const chIndex = state.characteristic.findIndex(ch => ch === characteristic)
    state.characteristic.splice(chIndex, 1)
  },
  SET_SELECTED_COMPETENCY (state, competency) {
    state.competency = competency
  },
  SET_INITIAL_LEVEL (state, initialLevel) {
    state.initialLevel = initialLevel
  },
  SET_INITIAL_LEVEL_TEXT (state, initialLevelText) {
    state.initialLevelText = initialLevelText
  },
  SET_TRAINING_DURATION (state, trainingDuration) {
    state.trainingDuration = trainingDuration
  },
  SET_PROGRESS_MEASURE (state, progressMeasure) {
    state.progressMeasure = progressMeasure
  }

}
